<vi-page *ngIf="userDetailsStore.state$ | async as state" [sidenavs]="true" [footer]="true">
  <vi-toolbar head color="white">
    <vi-icon-button left gtm="onBreadcrumbBack" gtmCategory="userDetails" (click)="back()">
      arrow_back
    </vi-icon-button>
    <vi-breadcrumbs
      *ngIf="routeData$ | async as routeData"
      left
      gtm="onBreadcrumb"
      gtmCategory="userDetails"
      formerPage="{{ 'GENERAL.PATH.INSTALLATION_DETAILS' | translate }}"
      currentPage="{{ 'GENERAL.PATH.USER_DETAILS' | translate }}"
      [navigateTo]="getNavigateTo(routeData.installationId)"
    ></vi-breadcrumbs>

    <vi-breadcrumbs
      *ngIf="!(routeData$ | async)"
      left
      gtm="onBreadcrumb"
      gtmCategory="userDetails"
      formerPage="{{ 'GENERAL.PATH.SEARCH' | translate }}"
      currentPage="{{ 'GENERAL.PATH.USER_DETAILS' | translate }}"
      [navigateTo]="'/search'"
    ></vi-breadcrumbs>
  </vi-toolbar>
  <vi-header head data-at-header *ngIf="!state.loading && state.loaded" color="white">
    <div *ngIf="user$ | async as user" class="header flex flex-col flex-auto">
      <h1>{{ user.firstName }} {{ user.lastName }}</h1>
    </div>
  </vi-header>

  <ng-container body *ngrxLet="userDetailsStore.isOmaUser$ as isOmaUser">
    <ng-container
      *ngIf="userDetailsStore.isUserDetailsGatewayError$ | async; else getUserDetailsSuccess"
    >
      <div
        class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
      >
        <img class="error-img" src="assets/img/installer-error.svg" data-at-failed-subscription />
        <p>
          {{ '+USER_DETAILS.GATEWAYS.GATEWAY_ERROR' | translate }}
        </p>
        <div
          class="flex flex-row lt-md:flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
        >
          <button
            class="back-button"
            gtm="onGoToPage"
            gtmAction="Back to search view"
            gtmCategory="search"
            mat-stroked-button
            data-at-go-back-to-search-view-button
            [routerLink]="['/search']"
          >
            <mat-icon>arrow_back</mat-icon>
            <span>{{ '+USER_DETAILS.BUTTON.GO_TO_SEARCH_VIEW' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #getUserDetailsSuccess>
      <vi-content body gap="8px">
        <vi-loader
          main
          data-at-loader
          *ngIf="state.loading && !state.loaded"
          [isLoading]="true"
          message="{{ '+USER_DETAILS.LOADING_MESSAGE' | translate }}"
        ></vi-loader>

        <ng-container main *ngIf="!state.loading && state.loaded">
          <vi-panel main data-at-status-panel>
            <div content>
              <div
                class="status-title-panel flex flex-row gap-[10px] justify-start items-center flex-initial"
              >
                <h3>{{ '+USER_DETAILS.STATUS.TITLE' | translate }}</h3>
                <app-pill
                  data-at-user-status
                  *ngrxLet="isActive$ as isActive"
                  [type]="isActive ? pillType.success : pillType.medium"
                  >{{
                    (isActive ? '+USER_DETAILS.STATUS.ACTIVE' : '+USER_DETAILS.STATUS.DISABLED')
                      | translate
                  }}</app-pill
                >
              </div>
            </div>
          </vi-panel>

          <div main class="panels flex flex-col gap-[1px]">
            <vi-panel
              data-at-user-panel
              *ngIf="userRole"
              title="{{ '+USER_DETAILS.PERSONAL_DETAILS.TITLE' | translate }}"
            >
              <div content class="flex flex-row flex-wrap gap-[50px] justify-start items-baseline">
                <vi-item
                  data-at-user-id-details
                  size="medium"
                  title="{{ '+USER_DETAILS.PERSONAL_DETAILS.USER_ID' | translate }}"
                  [value]="userRole.id | dash"
                >
                </vi-item>
                <ng-container *ngIf="userRoles$ | async as userRoles">
                  <vi-item
                    data-at-user-role-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.CAS_ROLE' | translate }}"
                    [value]="(userRoles?.length ? userRoles[0] : '') | dash"
                  >
                  </vi-item>
                </ng-container>
                <vi-item
                  data-at-user-type-details
                  size="medium"
                  title="{{ '+USER_DETAILS.PERSONAL_DETAILS.USER_TYPE' | translate }}"
                  [value]="userRole.type | dash"
                >
                </vi-item>
                <vi-item
                  *ngIf="userRole.type === viIntRole || userRole.type === viExtRole"
                  data-at-user-role
                  size="medium"
                  title="{{ '+USER_DETAILS.PERSONAL_DETAILS.USER_ROLE' | translate }}"
                  [value]="userRole.role | dash"
                >
                </vi-item>
                <div *ngIf="user$ | async as user" class="migrate-wrapper gap-[50px]">
                  <vi-item
                    [disableNumberFormatting]="true"
                    [attr.data-at-customer-number]="user.customerNumber | dash"
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.CUSTOMER_NUMBER' | translate }}"
                    [value]="user.customerNumber | dash"
                  >
                  </vi-item>
                  <p
                    data-at-installations-migration-btn-start-migration
                    *ngIf="user.customerNumber && canAccessInstallationsMigration()"
                    class="details__btn-installations-migration font-medium"
                    gtm="onOpen"
                    gtmAction="Migrate installations modal"
                    gtmCategory="userDetails"
                    (click)="openCustomerMigrationModal(user.customerNumber)"
                  >
                    {{ '+MIGRATION.BUTTON_LABEL' | translate }} »
                  </p>
                </div>
                <ng-container *ngIf="companyName$ | async as companyName">
                  <vi-item
                    data-at-user-type-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.USER_COMPANY' | translate }}"
                    [value]="companyName | dash"
                  ></vi-item>
                </ng-container>
                <vi-item
                  data-at-user-invitations-access
                  size="medium"
                  title="{{ '+USER_DETAILS.PERSONAL_DETAILS.VITOGUIDE_INVITATIONS' | translate }}"
                  [value]="
                    userHasAccessToInvitations$
                      | async
                      | booleanSuffix: ['BIVALENT.YES' | translate, 'BIVALENT.NO' | translate]
                  "
                ></vi-item>
              </div>
            </vi-panel>
            <vi-panel data-at-name-panel *ngIf="user$ | async as user">
              <div
                content
                class="panel-content flex flex-row gap-[50px] xs:gap-[55px] justify-between items-start"
              >
                <div
                  content
                  class="flex flex-row flex-wrap gap-[50px] justify-start items-center flex-[100%] max-w-[100%]"
                >
                  <vi-item
                    *ngIf="isOmaUser"
                    data-at-first-name-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.SALUTATION' | translate }}"
                    [value]="user.salutation | dash"
                  ></vi-item>
                  <vi-item
                    data-at-first-name-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.NAME' | translate }}"
                    [value]="user.firstName | dash"
                  ></vi-item>
                  <vi-item
                    data-at-last-name-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.LAST_NAME' | translate }}"
                    [value]="user.lastName | dash"
                  ></vi-item>
                  <vi-item
                    data-at-gender-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.GENDER' | translate }}"
                    [value]="user.gender | gender"
                  ></vi-item>
                  <ng-container *ngIf="userContact$ | async as userContact">
                    <vi-item
                      data-at-email-details
                      size="medium"
                      title="{{ '+USER_DETAILS.PERSONAL_DETAILS.EMAIL' | translate }}"
                      [value]="userContact.email | dash"
                    >
                    </vi-item>
                    <div class="email-verified-container">
                      <ng-container *ngIf="userContact.email !== '-'">
                        <app-pill
                          data-at-user-verified
                          *ngrxLet="isEmailVerified$ as isVerified"
                          [type]="isVerified ? pillType.success : pillType.medium"
                        >
                          {{
                            (isVerified
                              ? '+USER_DETAILS.EMAIL.VERIFIED'
                              : '+USER_DETAILS.EMAIL.NOT_VERIFIED'
                            ) | translate
                          }}
                        </app-pill>
                      </ng-container>
                      <ng-container *ngIf="!(isEmailVerified$ | async)">
                        <ng-container *ngIf="me">
                          <button
                            mat-stroked-button
                            color="primary"
                            [disabled]="disableResendEmail(me.iotRole)"
                            class="resend-confirmation-email"
                            gtm="onRequestSend"
                            gtmAction="Confirmation email"
                            gtmCategory="userDetails"
                            (click)="onResendConfirmationEmail(state?.userDetails?.loginId)"
                          >
                            {{ '+USER_DETAILS.BUTTON.RESEND_CONFIRMATION_EMAIL' | translate }}
                          </button>
                          <mat-icon
                            *ngIf="disableResendEmail(me.iotRole)"
                            class="icon"
                            [matTooltip]="
                              '+USER_DETAILS.BUTTON.DISABLED_RESEND_CONFIRMATION_EMAIL_TOOLTIP'
                                | translate
                            "
                            >info
                          </mat-icon>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div
                  class="edit-button-container flex flex-row justify-end items-center"
                  *ngIf="userRole"
                >
                  <ng-container *ngIf="me">
                    <button
                      mat-icon-button
                      appChangeUserDetails="personal"
                      gtm="onOpen"
                      gtmAction="User personal details edit modal"
                      gtmCategory="userDetails"
                      [disabled]="isEditButtonDisabled"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <mat-icon
                      *ngIf="isEditButtonDisabled"
                      class="icon"
                      [matTooltip]="'+USER_DETAILS.BUTTON.DISABLED_EDIT_USERS_TOOLTIP' | translate"
                      >info
                    </mat-icon>
                  </ng-container>
                </div>
              </div>
            </vi-panel>

            <vi-panel data-at-address-panel *ngIf="userAddress$ | async as userAddress">
              <div
                content
                class="panel-content flex flex-row gap-[50px] xs:gap-[55px] justify-between items-start"
              >
                <div
                  content
                  class="flex flex-row flex-wrap gap-[50px] justify-start items-center flex-[100%] max-w-[100%]"
                >
                  <vi-item
                    [disableNumberFormatting]="true"
                    data-at-street-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.STREET' | translate }}"
                    [value]="userAddress.street | dash"
                  ></vi-item>
                  <vi-item
                    data-at-house-number-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.HOUSE_NUMBER' | translate }}"
                    [value]="userAddress.houseNumber | dash"
                    [disableNumberFormatting]="true"
                  ></vi-item>
                  <vi-item
                    data-at-zip-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.ZIP' | translate }}"
                    [value]="userAddress.zip | dash"
                    [disableNumberFormatting]="true"
                  ></vi-item>
                  <vi-item
                    data-at-city-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.CITY' | translate }}"
                    [value]="userAddress.city | dash"
                  ></vi-item>
                  <vi-item
                    data-at-country-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.COUNTRY' | translate }}"
                    [value]="userAddress.country | country"
                  ></vi-item>
                  <vi-item
                    data-at-region-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.REGION' | translate }}"
                    [value]="userAddress.region | region: supportedCountries | dash"
                  ></vi-item>
                </div>
                <div
                  class="edit-button-container flex flex-row justify-end items-center"
                  *ngIf="userRole"
                >
                  <ng-container *ngIf="me">
                    <button
                      mat-icon-button
                      appChangeUserDetails="address"
                      gtm="onOpen"
                      gtmAction="User address details edit modal"
                      gtmCategory="userDetails"
                      [disabled]="isEditButtonDisabled"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <mat-icon
                      *ngIf="isEditButtonDisabled"
                      class="icon"
                      [matTooltip]="'+USER_DETAILS.BUTTON.DISABLED_EDIT_USERS_TOOLTIP' | translate"
                      >info
                    </mat-icon>
                  </ng-container>
                </div>
              </div>
            </vi-panel>

            <vi-panel data-at-phone-panel *ngIf="userContact$ | async as userContact">
              <div
                content
                class="panel-content flex flex-row gap-[50px] xs:gap-[55px] justify-between items-start"
              >
                <div
                  content
                  class="flex flex-row flex-wrap gap-[50px] justify-start items-center flex-[100%] max-w-[100%]"
                >
                  <vi-item
                    data-at-telephone-details
                    [disableNumberFormatting]="true"
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.TELEPHONE' | translate }}"
                    [value]="userContact.phoneNumber | formatPhoneNumber"
                  ></vi-item>
                  <vi-item
                    [disableNumberFormatting]="true"
                    data-at-mobile-phone-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.MOBILE_PHONE' | translate }}"
                    [value]="userContact.mobileNumber | formatPhoneNumber"
                  ></vi-item>
                  <vi-item
                    [disableNumberFormatting]="true"
                    *ngIf="userContact.faxNumber"
                    data-at-fax-details
                    size="medium"
                    title="{{ '+USER_DETAILS.PERSONAL_DETAILS.FAX' | translate }}"
                    [value]="userContact.faxNumber | formatPhoneNumber"
                  ></vi-item>
                </div>
                <div
                  class="edit-button-container flex flex-row justify-end items-center"
                  *ngIf="userRole"
                >
                  <ng-container *ngIf="me">
                    <button
                      mat-icon-button
                      appChangeUserDetails="contact"
                      gtm="onOpen"
                      gtmAction="User contact details edit modal"
                      gtmCategory="userDetails"
                      [disabled]="isEditButtonDisabled"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <mat-icon
                      *ngIf="isEditButtonDisabled"
                      class="icon"
                      [matTooltip]="'+USER_DETAILS.BUTTON.DISABLED_EDIT_USERS_TOOLTIP' | translate"
                      >info
                    </mat-icon>
                  </ng-container>
                </div>
              </div>
            </vi-panel>
            <ng-container *ngrxLet="userContact$ | async as userContact">
              <ng-container *ngrxLet="userDetailsStore.workCountryCode$ as workCountryCode">
                <vi-panel
                  data-at-language-panel
                  *ngIf="userContact || (workCountryCode && isOmaUser)"
                >
                  <div
                    content
                    class="panel-content flex flex-row gap-[50px] justify-between items-start"
                  >
                    <div
                      content
                      class="flex flex-row flex-wrap gap-[50px] xs:gap-[55px] justify-start items-center flex-[100%] max-w-[100%]"
                    >
                      <vi-item
                        data-at-language-details
                        size="medium"
                        title="{{ '+USER_DETAILS.PERSONAL_DETAILS.LANGUAGE' | translate }}"
                        [value]="userContact.language | language"
                      ></vi-item>
                      <vi-item
                        *ngIf="isOmaUser"
                        data-at-country-details
                        size="medium"
                        title="{{ '+USER_DETAILS.PERSONAL_DETAILS.WORK_COUNTRY_CODE' | translate }}"
                        [value]="workCountryCode ?? NO_VALUE"
                      ></vi-item>
                    </div>
                    <div
                      class="edit-button-container flex flex-row justify-end items-center"
                      *ngIf="userRole"
                    >
                      <ng-container *ngIf="me">
                        <button
                          mat-icon-button
                          appChangeUserDetails="other"
                          gtm="onOpen"
                          gtmAction="User language edit modal"
                          gtmCategory="userDetails"
                          [disabled]="isEditButtonDisabled"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                        <mat-icon
                          *ngIf="isEditButtonDisabled"
                          class="icon"
                          [matTooltip]="
                            '+USER_DETAILS.BUTTON.DISABLED_EDIT_USERS_TOOLTIP' | translate
                          "
                          >info
                        </mat-icon>
                      </ng-container>
                    </div>
                  </div>
                </vi-panel>
              </ng-container>
            </ng-container>

            <vi-panel data-at-reset-password-panel *ngIf="userRole">
              <div
                content
                class="flex flex-row flex-wrap gap-[10px] justify-start items-center xs:justify-center"
              >
                <button
                  data-at-reset-password-btn
                  [disabled]="!(isEmailVerified$ | async)"
                  id="reset-password-btn"
                  mat-stroked-button
                  color="primary"
                  gtm="onRequestSend"
                  gtmAction="Reset password email"
                  gtmCategory="userDetails"
                  (click)="onResetPassword(userRole.id)"
                >
                  {{ '+USER_DETAILS.BUTTON.RESET_PASSWORD' | translate }}
                </button>
                <mat-icon
                  *ngIf="!(isEmailVerified$ | async)"
                  class="icon"
                  [matTooltip]="'+USER_DETAILS.BUTTON.RESET_PASSWORD_TOOLTIP' | translate"
                  >info
                </mat-icon>
              </div>
            </vi-panel>
          </div>

          <ng-container *ngIf="gatewaysVM$ | async as gatewaysVM">
            <ng-container *ngIf="user$ | async as user">
              <app-user-gateway-list
                [gatewaysVM]="gatewaysVM"
                [user]="user"
                [userDetails]="state.userDetails"
              >
              </app-user-gateway-list>
            </ng-container>
          </ng-container>

          <app-user-booking-list
            *ngIf="userRole?.type === IAMRoles.maintainer"
            [userDetails]="state.userDetails"
          >
          </app-user-booking-list>
        </ng-container>
      </vi-content>
    </ng-template>
  </ng-container>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
